const options = {
  5: "bg-emerald-400/5",
  10: "bg-emerald-400/10",
  25: "bg-emerald-400/25",
  50: "bg-emerald-400/50",
  75: "bg-emerald-400/75",
  90: "bg-emerald-400/90",
  100: "bg-emerald-400",
};

const from = {
  5: "from-emerald-400/5",
  10: "from-emerald-400/10",
  25: "from-emerald-400/25",
  50: "from-emerald-400/50",
  75: "from-emerald-400/75",
  90: "from-emerald-400/90",
  100: "from-emerald-400",
};

export default function getBackgroundEmerald400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
